
import { defineComponent, reactive, toRefs, watchEffect, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import { forceCloseByContract } from '../api'
import { useEnterpriseRemote } from '../../enterprise-remote'
import { required } from '@/utils/rules'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false
    },
    companyUuid: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'onSuccess'],
  setup(props, { emit }) {
    const rules = {
      companyUuid: [required],
      externalContractNo: [required],
      businessType: [required]
    }
    const remoteData1 = useEnterpriseRemote()
    const data = reactive({
      visible: false,
      formRef: undefined,
      formData: ref<any>({
        companyUuid: props.companyUuid || ''
      })
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    // 关闭动画结束后再通知父组件卸载，避免 Teleport DOM 被提前移除
    const onClosed = (): void => {
      emit('update:modelValue', false)
      emit('onSuccess')
    }

    const handleCancel = (): void => {
      data.visible = false
    }

    const handleSubmit = () => {
      data.formRef.validate(async (valid) => {
        if (valid) {
          const p = { ...data.formData }
          const [err] = await toResult(forceCloseByContract(p))
          if (err) return false
          ElMessage.success('强制关闭成功')
          data.visible = false
        }
      })
    }

    return {
      ...toRefs(data),
      handleSubmit,
      handleCancel,
      onClosed,
      remoteData1,
      rules
    }
  }
})
